import { LOCALE_ID, Pipe, PipeTransform, inject } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { AppFacadeService } from '../services/app-facade.service';
import { take } from 'rxjs';

@Pipe({
    standalone: false,
    name: 'formatCurrency'
})
export class FormatCurrencyPipe implements PipeTransform {
    private readonly currencyPipe = inject(CurrencyPipe);
    private readonly appFacadeService = inject(AppFacadeService);
    private readonly locale = inject(LOCALE_ID);

    transform(value: string | number | undefined | null, currencyCode?: string | null): string {
        if (value === undefined || value === null) {
            return '-';
        }

        let result = '-';
        const numericValue = typeof value === 'string' ? +value : value;

        const subscription = this.appFacadeService
            .getCurrency()
            .pipe(take(1))
            .subscribe(currency => {
                currencyCode = currencyCode || currency;
                if (!currencyCode) {
                    result = !isNaN(numericValue as number) ? numericValue.toFixed(2) : '-';
                } else if (typeof value === 'number' || !isNaN(numericValue as number)) {
                    let formattedValue = this.currencyPipe.transform(Math.abs(numericValue), currencyCode, 'code', '1.2-2', this.locale);

                    if (formattedValue !== null) {
                        formattedValue = formattedValue.replace(/([A-Za-z]+)(\d)/, '$1 $2');
                        if (numericValue < 0) {
                            formattedValue = formattedValue.replace(/([A-Za-z]+)\s/, '$1 -');
                        }
                        result = formattedValue;
                    } else {
                        result = '0.00';
                    }
                } else {
                    result = '-';
                }
            });

        // Unsubscribe to prevent memory leaks
        subscription.unsubscribe();
        return result;
    }
}
